const MS_IN_A_DAY: number = 24 * 60 * 60 * 1000; // 1 day in milliseconds
const MS_IN_A_WEEK: number = 7 * MS_IN_A_DAY; // 1 week in milliseconds
const MS_IN_A_MONTH: number = 31 * MS_IN_A_DAY; // 1 month in millisceconds
const MS_IN_A_YEAR: number = 365 * MS_IN_A_DAY; // 1 years in muliseconds

export interface TimeDeltaReadable {
    unit: string;
    value: number;
}

export function timeDeltaHelper(timeStamp: Date, now: Date = new Date(), locale: string = 'en-US'): TimeDeltaReadable {
    const pastDate: Date = new Date(timeStamp);
    const weekDayOffset: number = weekStartOffset(locale);

    // Calculate differences in calendar units
    const timeDiff = now.getTime() - pastDate.getTime();
    const daysDiff = ((now.getDay() + weekDayOffset) % 7) - ((pastDate.getDay() + weekDayOffset) % 7);
    const weeksDiff = Math.floor(timeDiff / MS_IN_A_WEEK);
    const monthsDiff = Math.abs(now.getMonth() - pastDate.getMonth());
    const yearsDiff = now.getFullYear() - pastDate.getFullYear();

    if (timeDiff < MS_IN_A_DAY && daysDiff === 0) {
        return { unit: 'today', value: 0 };
    } else if (timeDiff < MS_IN_A_WEEK && daysDiff > 0) {
        return { unit: 'day', value: Math.abs(daysDiff) };
    } else if (timeDiff < MS_IN_A_MONTH) {
        return { unit: 'week', value: daysDiff <= 0 ? weeksDiff + 1 : weeksDiff };
    } else if (timeDiff < MS_IN_A_YEAR || yearsDiff === 0) {
        // Account for leap years
        return { unit: 'month', value: monthsDiff };
    }

    return { unit: 'year', value: yearsDiff };
}

// https://stackoverflow.com/questions/53382465/how-can-i-determine-if-week-starts-on-monday-or-sunday-based-on-locale-in-pure-j
function _weekStart(region: string, language: string): number {
    const regionSat: RegExpMatchArray = 'AEAFBHDJDZEGIQIRJOKWLYOMQASDSY'.match(/../g)!; // List of region codes that start hte week on sat
    const regionSun: RegExpMatchArray =
        'AGARASAUBDBRBSBTBWBZCACNCODMDOETGTGUHKHNIDILINJMJPKEKHKRLAMHMMMOMTMXMZNINPPAPEPHPKPRPTPYSASGSVTHTTTWUMUSVEVIWSYEZAZW'.match(
            /../g
        )!; // List of region codes that start the week on sun
    const languageSat: string[] = ['ar', 'arq', 'arz', 'fa']; // List of langs that start the week on sat
    const languageSun: RegExpMatchArray =
        'amasbndzengnguhehiidjajvkmknkolomhmlmrmtmyneomorpapssdsmsnsutatethtnurzhzu'.match(/../g)!; // List of langs that start the week on sun

    return region
        ? regionSun.includes(region)
            ? 0 // sun
            : regionSat.includes(region)
              ? 1 // sat
              : -1 // mon
        : languageSun.includes(language)
          ? 0 // sun
          : languageSat.includes(language)
            ? 1 // sat
            : -1; // mon
}

function weekStartOffset(locale: string): number {
    const parts = locale.match(
        /^([a-z]{2,3})(?:-([a-z]{3})(?=$|-))?(?:-([a-z]{4})(?=$|-))?(?:-([a-z]{2}|\d{3})(?=$|-))?/i
    );

    if (!parts) {
        console.warn(`Invalid locale: ${locale}`);
        return 0;
    }

    return _weekStart(parts[4], parts[1]);
}
